import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

interface GroupedBarChartProps {
  data: { month: string; generated: number; exported: number }[];
  height?: number;
}

export default function GroupedBarChart({ data, height = 240 }: GroupedBarChartProps) {
  if (!data || data.length === 0) {
    return (
      <div className="flex items-center justify-center h-48 text-text-tertiary text-sm">
        No data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 4 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#EEEEEE" vertical={false} />
        <XAxis dataKey="month" tick={{ fontSize: 11, fill: '#999999' }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fontSize: 11, fill: '#999999' }} axisLine={false} tickLine={false} />
        <Tooltip
          contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #DDDDDD' }}
          formatter={(val: unknown, name: unknown) => [`${val} kWh`, name === 'generated' ? 'Generated' : 'Exported']}
        />
        <Legend
          iconType="square"
          iconSize={10}
          wrapperStyle={{ fontSize: 12, paddingTop: 8 }}
          formatter={(value) => value === 'generated' ? 'Generated (kWh)' : 'Exported (kWh)'}
        />
        <Bar dataKey="generated" fill="#C25A0A" radius={[3, 3, 0, 0]} maxBarSize={24} />
        <Bar dataKey="exported" fill="#2472C8" radius={[3, 3, 0, 0]} maxBarSize={24} />
      </BarChart>
    </ResponsiveContainer>
  );
}
